'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _mapProps = require('recompose/mapProps');

var _mapProps2 = _interopRequireDefault(_mapProps);

var _getContext = require('recompose/getContext');

var _getContext2 = _interopRequireDefault(_getContext);

var _dataSelectors = require('../selectors/dataSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ComposedTableBodyContainer = function ComposedTableBodyContainer(OriginalComponent) {
  return (0, _compose2.default)((0, _getContext2.default)({
    components: _react.PropTypes.object,
    selectors: _react.PropTypes.object
  }), (0, _reactRedux.connect)(function (state, props) {
    return {
      visibleRowIds: (0, _dataSelectors.visibleRowIdsSelector)(state),
      className: (0, _dataSelectors.classNamesForComponentSelector)(state, 'TableBody'),
      style: (0, _dataSelectors.stylesForComponentSelector)(state, 'TableBody')
    };
  }), (0, _mapProps2.default)(function (props) {
    var components = props.components,
        otherProps = _objectWithoutProperties(props, ['components']);

    return _extends({
      Row: props.components.Row
    }, otherProps);
  }))(function (_ref) {
    var Row = _ref.Row,
        visibleRowIds = _ref.visibleRowIds;
    return _react2.default.createElement(OriginalComponent, {
      rowIds: visibleRowIds,
      Row: Row
    });
  });
};

exports.default = ComposedTableBodyContainer;


//////////////////
// WEBPACK FOOTER
// ./~/griddle-react/dist/module/components/TableBodyContainer.js
// module id = 1114
// module chunks = 0